import { AgentLogoType, Property } from '@propertypal/shared/src/types/property';
import getSellingAgent from '@propertypal/shared/src/utils/property/getSellingAgent';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../typography';
import { AgentLogo, Container, PremierContainer } from './PropertyBoxFooter.style';

interface Props {
  property: Property;
  premium: boolean;
  logos?: AgentLogoType[];
}

const PropertyBoxFooter: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const sellingAgent = getSellingAgent(props.property);
  const hasWhiteBg = props.property.account.logo?.premierBackgroundColour === '#ffffff';

  if (props.premium) {
    return (
      <PremierContainer color={props.property.account.logo?.premierBackgroundColour}>
        {!!sellingAgent && (
          <Text fontSize={12} color={hasWhiteBg ? theme.darkGrey : theme.white}>
            Marketed by {sellingAgent.organisation}
          </Text>
        )}

        {props?.logos &&
          props.logos?.length > 0 &&
          props.logos.map((logo) => (
            <AgentLogo
              src={logo.url}
              key={logo.url}
              alt={`${sellingAgent?.organisation} Logo`}
              aria-hidden="true"
              loading="lazy"
              width={logo.width}
              height={logo.height}
            />
          ))}
      </PremierContainer>
    );
  }

  return (
    <Container>
      {props?.logos &&
        props.logos?.length > 0 &&
        props.logos.map((logo) => (
          <AgentLogo
            src={logo.url}
            key={logo.url}
            alt={`${sellingAgent?.organisation} Logo`}
            aria-hidden="true"
            loading="lazy"
            width={logo.width}
            height={logo.height}
          />
        ))}

      {!!sellingAgent && (
        <div>
          <Text fontSize={12}>Marketed by</Text>
          <Text fontSize={12}>{sellingAgent.organisation}</Text>
        </div>
      )}
    </Container>
  );
};

export default PropertyBoxFooter;
